import { Box, MenuItem, TextField, Typography } from '@mui/material'
import { Interval } from 'luxon'
import React from 'react'
import { WarehouseDDL } from '../../components/Almacen'
import { ProductOriginsDDL } from '../../components/Producto/ProductOrigins/ProductOriginsDDL'
import { DateRangeFilter } from '../../components/WorkOrder/WorkOrderDashboard/SearchFilter/DateRangeFilter'
import { ZoneDDL } from '../../components/Zone'
import { InputItem, SelectedFiltersValues } from './KardexFilters'

interface RenderKardexFilterProps {
  inputItem: InputItem
  selectedFiltersValues: SelectedFiltersValues
  handleUTCSelectedDateTimeChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void
  handleChangeDDLOption: any
  handleProductCode: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
}

const typeStockMovementProcess = [
  { id: 1, value: 'Recepción' },
  { id: 2, value: 'Put-Away' },
  { id: 3, value: 'Picking' },
  { id: 4, value: 'Pre-despacho' },
  { id: 5, value: 'Despacho' },
  { id: 6, value: 'Transferencia' }
]

export const RenderKardexFilter: React.FC<RenderKardexFilterProps> = ({
  inputItem: { option },
  handleUTCSelectedDateTimeChange,
  selectedFiltersValues: finalRequest,
  handleChangeDDLOption,
  handleProductCode
}) => {
  if (option === 'Seleccione una opción...')
    return (
      <Box
        display={'flex'}
        width={'100%'}
        justifyItems={'center'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Typography variant='subtitle1'>
          Seleccione una opción para desplegar
        </Typography>
      </Box>
    )

  if (option === 'dateRange')
    return (
      <DateRangeFilter
        handleSearch={handleUTCSelectedDateTimeChange}
        initialDate={finalRequest.initialDate}
        finalDate={finalRequest.finalDate}
        isValid={
          finalRequest.initialDate && finalRequest.finalDate
            ? Interval.fromDateTimes(
                finalRequest.initialDate,
                finalRequest.finalDate
              ).isValid
            : false
        }
        isShowed={true}
        variant='outlined'
      />
    )
  if (option === 'product')
    return (
      <TextField
        name='product'
        value={finalRequest.product}
        onChange={(event) => handleProductCode(event)}
        variant='outlined'
        fullWidth
      />
    )
  if (option === 'warehouseId')
    return (
      <WarehouseDDL
        onChange={handleChangeDDLOption}
        value={finalRequest.warehouseId || -1}
        type='outlined'
        fullWidth
        valueKey='warehouseName'
      />
    )

  if (option === 'zoneId')
    return (
      <ZoneDDL
        onChange={handleChangeDDLOption}
        value={finalRequest.productOriginId || -1}
        variant='outlined'
        fullWidth
      />
    )

  if (option === 'productOrigin')
    return (
      <ProductOriginsDDL
        onChange={handleChangeDDLOption}
        value={finalRequest.productOriginId || 0}
        type='outlined'
        fullWidth
        valueKey='origin'
      />
    )

  if (option === 'typeMovementId')
    return (
      <TextField
        variant='outlined'
        id='typeMovementId'
        name='typeMovementId'
        select
        value={finalRequest.typeMovementId || 0}
        onChange={handleChangeDDLOption}
        fullWidth
      >
        <MenuItem key={`typeprocess-${0}`} value={0}>
          {'Tipo de proceso...'}
        </MenuItem>
        {typeStockMovementProcess !== undefined
          ? typeStockMovementProcess.map(({ id, value }) => (
              <MenuItem key={`typeprocess-${id}`} value={value}>
                {value}
              </MenuItem>
            ))
          : []}
      </TextField>
    )

  return <Typography>Opción no implementada</Typography>
}
